// Frontend ads script - Entry point for webpack build
// This file imports and initializes all frontend ad functionality